/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class ServiceAccountDetailsWithAdditionalInfo extends models.ServiceAccountDetails {
    getFixupPrototypeFunction() { return ServiceAccountDetailsWithAdditionalInfo.fixupPrototype; }

    static newInstance(model: Partial<ServiceAccountDetailsWithAdditionalInfo>): ServiceAccountDetailsWithAdditionalInfo {
        let obj = Object.assign(new ServiceAccountDetailsWithAdditionalInfo(), model);
        ServiceAccountDetailsWithAdditionalInfo.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<ServiceAccountDetailsWithAdditionalInfo>): ServiceAccountDetailsWithAdditionalInfo {
        if (!model) return null;
        return ServiceAccountDetailsWithAdditionalInfo.newInstance(<ServiceAccountDetailsWithAdditionalInfo> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: ServiceAccountDetailsWithAdditionalInfo) {
        if (!obj) return;

        models.ServiceAccountDetailsWithAdditionalInfo.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: ServiceAccountDetailsWithAdditionalInfo): boolean {
        if (models.ServiceAccountDetails.setPrototype(obj))
        {
            return true; // A polymorphic type, skip overwriting the prototype.
        }
        Object.setPrototypeOf(obj, ServiceAccountDetailsWithAdditionalInfo.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        super.fixupFields();
        if (this.sync_status) {
            models.ServiceAccountSync.fixupPrototype(this.sync_status);
        }
        if (this.child_account_count) {
            for (let val of this.child_account_count) {
                models.ServiceAccountChild.fixupPrototype(val);
            }
        }
        if (this.parent_accounts_info) {
            for (let val of this.parent_accounts_info) {
                models.ServiceAccountParentInfo.fixupPrototype(val);
            }
        }
    }

    /**
     * List of child account counts for each account.
     */
    child_account_count: Array<models.ServiceAccountChild>;

    /**
     * List of parent account hierarchy information for each account.
     */
    parent_accounts_info: Array<models.ServiceAccountParentInfo>;

    /**
     * Sync status for each account.
     */
    sync_status: models.ServiceAccountSync;

}
